// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__34Jtk","list":"styles_list__1rTNm"};